function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconArrowCircleChevronUpFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M1.031 16a14.969 14.969 0 1029.938 0A14.969 14.969 0 001.03 16zm22.453 2.868l-1.745 1.748L16 14.877l-5.739 5.74-1.745-1.749L16 11.384l7.484 7.484z",
    fill: props.color
  }));
}

export default SvgIconArrowCircleChevronUpFilled;